import { liangBarsky2 } from "@thi.ng/geom-clip-line";
import { Line } from "../api/line";
import { Rect } from "../api/rect";
import { pclike } from "../internal/pclike";
export function line(...args) {
    return pclike(Line, args);
}
export const clippedLine = (l, bounds) => {
    const res = bounds instanceof Rect
        ? liangBarsky2(l.points[0], l.points[1], bounds.pos, bounds.max())
        : liangBarsky2(l.points[0], l.points[1], bounds[0], bounds[1]);
    if (res) {
        return new Line([res[0], res[1]], Object.assign({}, l.attribs));
    }
};
